import { useEffect } from 'react';
import { useTitleBarNudgeStore } from '@frontend/user-preferences';

interface Props {
  showExpandModeNudge: boolean | undefined;
  setShowExpandModeNudge: (val: boolean) => void;
}

export const useSyncExpandModeNudge = ({ showExpandModeNudge, setShowExpandModeNudge }: Props) => {
  useEffect(() => {
    if (showExpandModeNudge === undefined) return;

    const { showExpandModeNudge: storeValue, setShowExpandModeNudge: setStoreValue } = useTitleBarNudgeStore.getState();

    if (storeValue !== showExpandModeNudge) {
      setStoreValue(showExpandModeNudge);
    }
  }, [showExpandModeNudge]);

  useEffect(() => {
    const unsub = useTitleBarNudgeStore.subscribe((state, prev) => {
      if (state.showExpandModeNudge === prev.showExpandModeNudge) return;

      setShowExpandModeNudge(state.showExpandModeNudge);
    });

    return unsub;
  }, [setShowExpandModeNudge]);
};
